"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_router_1 = require("fluxible-router");
class SearchWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = new SearchWidgetState();
        this.onSearchTextChange = this.onSearchTextChange.bind(this);
    }
    onSearchTextChange(event) {
        this.setState({ searchText: event.target.value });
    }
    render() {
        return (React.createElement("div", { className: 'well' },
            React.createElement("h4", null, "Blog Search"),
            React.createElement("div", { className: 'input-group' },
                React.createElement("input", { type: 'text', value: this.state.searchText, onChange: this.onSearchTextChange, className: 'form-control' }),
                React.createElement("span", { className: 'input-group-btn' },
                    React.createElement(fluxible_router_1.NavLink, { href: '/blog?search=' + this.state.searchText, className: 'btn btn-default', type: 'button' },
                        React.createElement("span", { className: 'glyphicon glyphicon-search' }))))));
    }
}
exports.default = SearchWidget;
class SearchWidgetState {
}
